import axios from 'axios'
import { BUSCAR_ENCOMENDA_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarEncomendaItinerario (idItinerario) {
  const url = `${URL}/encomendas/itinerario/${idItinerario}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ENCOMENDA_ITINERARIO,
        payload: response
      })
  );
}